import { render, staticRenderFns } from "./roomAssignment.vue?vue&type=template&id=36b52ffe&scoped=true&"
import script from "./roomAssignment.vue?vue&type=script&lang=js&"
export * from "./roomAssignment.vue?vue&type=script&lang=js&"
import style0 from "./roomAssignment.vue?vue&type=style&index=0&id=36b52ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b52ffe",
  null
  
)

export default component.exports